import React, { useState, useRef, useEffect } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import Falcon from "../assest/l.png";
import tactosImage from "../assest/tactosnew.png";
import { motion } from "framer-motion";
import { Link, NavLink } from "react-router-dom";
import GradientOverlay from "./GradientOverlay";
import md5 from "blueimp-md5";
import { logout as logoutApi } from "../utils/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../utils/authContext';
import { useSelector } from 'react-redux';
import { isGuest } from "../utils/isGuest";

function Header({
  fullName: propFullName,
  email: propEmail,
}) {
  const { logoutStartup, logoutInvestor, investor } = useAuth();
  const navigate = useNavigate();


  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const fullName =
    propFullName ||
    localStorage.getItem("startupName") ||
    "";

  const email =
    propEmail ||
    localStorage.getItem("email") ||
    "";

  const handleInvestorLogout = async () => {
    try {
      setIsLoggingOut(true);
      await logoutInvestor();
      setUserMenuOpen(false);
      navigate("/");
    } catch (error) {
      console.error("Investor logout failed:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  // const logoUrl = useSelector((`state) => state.logo.logoUrl);
  let logoUrl = localStorage.getItem("logoUrl");
  if (!logoUrl || logoUrl.trim() === "") {
    logoUrl = null;
  }
  // console.log("Stored Logo:", logoUrl);

  // 2. Compute gravatar hash if email exists
  const gravatarHash = email ? md5(email.trim().toLowerCase()) : null;
  const gravatarUrl = gravatarHash
    ? `https://www.gravatar.com/avatar/${gravatarHash}?s=40&d=identicon`
    : null;

  // 3. Decide which src to use
  const avatarSrc = logoUrl || gravatarUrl;

  const navbarRef = useRef(null);
  const placeholderRef = useRef(null);

  // Sticky & resize effects
  useEffect(() => {
    const handleScroll = () => {
      if (!navbarRef.current) return;
      const offsetTop =
        navbarRef.current.offsetTop -
        parseInt(getComputedStyle(navbarRef.current).marginTop, 10);
      setIsSticky(window.scrollY > offsetTop);
    };

    const handleResize = () => {
      if (!navbarRef.current) return;
      setNavbarHeight(navbarRef.current.offsetHeight);
    };

    handleResize();
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.setProperty("--navbar-height", `${navbarHeight}px`);
  }, [navbarHeight]);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      await logoutStartup();
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <header
      className={`site-header group/header relative z-50 transition-[background,shadow] text-[14px] w-full ${isSticky ? "lqd-is-sticky" : ""
        }`}
    >
      <GradientOverlay />

      {/* Placeholder for sticky navbar */}
      <div
        ref={placeholderRef}
        className={isSticky ? "" : "hidden"}
        style={{ height: "var(--navbar-height)" }}
      ></div>

      <div className="site-header-nav-wrap flex flex-col">
        <nav
          ref={navbarRef}
          className={`
    site-header-nav
    relative top-0 z-40
    flex items-center justify-between
    w-full mx-auto
    rounded-b-xl px-6 py-4
    text-[14px] font-medium
    shadow-[0px_4px_55px_hsl(0_0%_0%/5%)]
    backdrop-blur-xl backdrop-saturate-[125%]
    
    max-sm:px-2
    sm:max-w-[calc(576px-2rem)]
    md:max-w-[calc(768px-2rem)]
    lg:max-w-[calc(1024px-2rem)]
    xl:max-w-[calc(1170px-2rem)]
    min-[1500px]:max-w-[calc(1440px-2rem)]
    
    group-[.lqd-is-sticky]/header:fixed
    group-[.lqd-is-sticky]/header:start-1/2
    group-[.lqd-is-sticky]/header:-translate-x-1/2
  `}
          style={{ backgroundColor: "hsla(20, 20%, 97%, 0.6)" }}
        >
          {/* Left: Logo */}

          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="site-logo relative basis-1/3 max-lg:basis-1/3 max-sm:shrink-0"
          >
            <Link to="/" className="flex flex-row items-center max-h-11">
              <img
                src={tactosImage}
                alt="logo"
                className="object-contain h-14 mt-3 w-[250px]"
              />
            </Link>
          </motion.div>

          <div
            className={`
              site-nav-container basis-1/3 transition-all 
              lg:static lg:max-h-full lg:w-auto 
              max-lg:absolute max-lg:right-0 max-lg:top-full 
              max-lg:max-h-0 max-lg:w-full max-lg:overflow-hidden 
              max-lg:bg-white
              ${menuOpen ? "max-lg:max-h-[400px]" : ""}
            `}
          >
            <ul
              className="
        flex items-center justify-center gap-8 whitespace-nowrap text-center
        max-xl:gap-5 
        max-lg:flex-col max-lg:items-start max-lg:gap-5 max-lg:p-6
      "
            >
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Home</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full 
                                      bg-[#fd3e3d] 
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/solutions"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Tech Support</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>

               <li>
                <NavLink
                  to="/events"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Events</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/mentormaindashboard"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Mentors</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>

              {/* <li>
                <li>
                <NavLink
                  to="/mentormaindashboard"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Mentors</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/events"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Events</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/startups"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Invest in Start-Ups</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li> */}
              {!isGuest()&&localStorage.getItem("Startuptoken")&&(
                  <li>
                <NavLink
                  to="/investors"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Investors</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
              )}
            
              {/* <li>
                <NavLink
                  to="/jobs"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Jobs</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d] 
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink
                  to="/matrimony"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Matrimony</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full  
                                      bg-[#fd3e3d] 
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li> */}


                <li>
                <NavLink
                  to="/forumsmain"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Forums</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full 
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
              
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    `relative group px-1 ${isActive ? "text-[#333333B2]" : "text-foreground/70"
                    } transition-colors hover:text-[#333333B2]`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className="font-heading font-medium">Contact Us</span>
                      <span
                        className={`
                                      absolute top-6 lg:top-9 left-1 lg:left-0 h-[5px] w-full 
                                      bg-[#fd3e3d]
                                      origin-left 
                                      transition-transform duration-300 ease-out 
                                      group-hover:scale-x-100 
                                      ${isActive ? "scale-x-100" : "scale-x-0"}
                                    `}
                      />
                    </>
                  )}
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="flex basis-1/3 justify-end gap-2 max-lg:basis-2/3">

            {(fullName || investor) ? (
              <div className="relative">
                <button
                  onClick={() => setUserMenuOpen(open => !open)}
                  className="flex items-center gap-2"
                >

                  {/* {!isGuest() && (
                    <img
                      src={avatarSrc}
                      alt="Profile"
                      className="h-10 w-10 rounded-full object-cover hidden md:block 
"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = gravatarUrl;
                      }}
                    />
                  )} */}

                  <span className="text-sm font-medium text-gray-700 hover:text-gray-900 flex items-center h-10 flex-shrink-0">
                    {fullName || investor?.name || investor?.email}
                  </span>

                  <svg
                    className="w-3 h-3 md:w-4 md:h-4 text-gray-500 hidden sm:block"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {userMenuOpen && (
                  <div
                    ref={el => {
                      if (el && !el._outsideClickListener) {
                        el._outsideClickListener = (event) => {
                          if (
                            el &&
                            !el.contains(event.target) &&
                            !event.target.closest("button.flex.items-center.gap-2")
                          ) {
                            setUserMenuOpen(false);
                          }
                        };
                        document.addEventListener("mousedown", el._outsideClickListener);
                      }
                    }}
                    className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50"
                  >
                    {fullName && (
                      <Link to="/startup-dashboard">
                        <div className="px-4 py-2 text-sm text-gray-800 hover:bg-gray-100">
                          Startup Dashboard
                        </div>
                      </Link>
                    )}

                    <button
                      onClick={fullName ? handleLogout : handleInvestorLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      Log out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link
                  to="/startup-reg"
                  className="lqd-btn hidden md:inline-flex items-center justify-center gap-1.5 text-[15px] font-medium rounded-full transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 bg-background text-heading-foreground shadow px-4 py-2 hover:bg-[#fd3e3d] hover:text-white"
                >
                  Register
                </Link>
                <Link
                  to="/login"
                  className="lqd-btn md:inline-flex items-center justify-center gap-1.5 text-[15px] font-medium rounded-full transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 bg-background text-heading-foreground shadow px-4 py-2 lg:px-4 lg:py-2 hover:bg-[#fd3e3d] hover:text-white"
                >
                  Login
                </Link>
              </>
            )}
            <button
              className="mobile-nav-trigger group flex size-10 shrink-0 items-center justify-center rounded-full bg-foreground/20 lg:hidden"
              onClick={() => setMenuOpen((open) => !open)}
              aria-label="Toggle menu"
            >
              {menuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;